<template>
    <div class="assignment-route">

        <router-link :to="link" class="assignment-block-link">
            <img :src="assignment.image" :alt="assignment.title" />
            <span class="assignment-icon" :class="type_class"></span>
            <h2>{{ assignment.title }}</h2>
            <p>{{ assignment.subtitle }}</p>
        </router-link>

        <div class="assignment__information">
            <progress-bar :assignment="assignment" :steps="steps" :progress="progress" :autolink="true" :mini="true" ></progress-bar>
            <span class="assignment__meta">
                <span class="assignment__time tag">{{ assignment.time }} minuten</span>
                <span class="assignment__group-size tag" :class="groupSize.class" :title="groupSize.title">{{ assignment.group_size }}</span>
            </span>
        </div>

        <primary-button :link="link" :disabled="isDisabled">{{ buttonText }}</primary-button>

    </div>
</template>

<script>
import PrimaryButton from 'js/components/elements/PrimaryButton.vue';
import ProgressBar from 'js/components/elements/ProgressBar.vue';

export default {
    components: { PrimaryButton, ProgressBar },
    props: {
        assignment: {},
        user: {},
        progress: {},
        disableIfUnfinished: {
            type: Boolean,
            default: false,
        },
        disable: {
            type: Boolean,
            default: false,
        },
        ignoreProgress: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        steps: function() {
            // prevent exception when steps have not been loaded yet
            if (this.assignment.steps == null) {
                return []
            }
            return this.assignment.steps.map( id => this.$store.state.steps.storage[id])
        },
        link: function() {
            if ( this.isDisabled ) return this.$route.path
            return { name: 'assignment', params: { assignmentId: this.assignment.id}}
        },
        isRetaking: function() {
            return this.progress && this.progress.isRetaking
        },
        finished: function() {
            return this.progress && this.progress.finished
        },
        isDisabled: function() {
            return this.disable || ( !this.finished && this.disableIfUnfinished )
        },
        icon: function() {
            return '/img/icon-'+this.assignment.type+'@2x.png'
        },
        type_class: function() {
            return 'icon-' + this.assignment.type
        },
        buttonText: function() {

            if ( this.disable ) {
                return 'Niet in demo'
            }

            if ( this.disableIfUnfinished ) {

                if ( this.finished ) {
                    return  'Bekijk'
                }

                return 'Bezig'
            }


            if ( this.ignoreProgress ) {
                return 'Bekijk'
            }

            if ( this.isRetaking ) {
                return  'Opnieuw inleveren!'
            }

            if ( this.finished ) {
                return  'Klaar'
            }


            if ( this.progress ) {
                return 'Verder'
            }

            return 'Begin'

        },
        groupSize: function() {
            switch (this.assignment.group_size) {
            case 1:
                return {
                    class: 'assignment__group-size--individual',
                    title: 'Individueel',
                }
            case 2:
                return {
                    class: 'assignment__group-size--pair',
                    title: 'Groepjes van twee',
                }
            case 3:
                return {
                    class: 'assignment__group-size--trio',
                    title: 'Groepjes van drie',
                }
            default: {
                const numbers = [ 'nul', 'een', 'twee', 'drie', 'vier', 'vijf', 'zes', 'zeven', 'acht', 'negen', 'tien']
                return {
                    class: 'assignment__group-size--multi',
                    title: 'Groupjes van ' + numbers[this.assignment.group_size],
                }
            }}
        }
    }
}
</script>


<style lang="scss">

    @import 'global';

    $assignment-icon-border-size: 3px;
    $assignment-icon-size: 52px;

    .assignment-route {

        width: 300px;
        padding: 20px;
        margin: 5%;
        display: inline-block;

        text-align: center;

        img {
            width: 220px;
            height: 220px;
            border: none; //1px solid #e5eae9;
            border-radius: 50%;
            margin: 0 auto;
        }

        .assignment-icon {
            position: absolute;
            top: 192px;
            left: 50%;
            margin-left: -($assignment-icon-size+$assignment-icon-border-size)/2;

            transition: transform 0.15s ease-out;
        }

        &:hover {
            .assignment-icon {
                transform: translate(0, -8px);
            }
        }

        .assignment-block-link {
            display: block;
            text-decoration: none;
            position: relative;

        }

        h2, p {
            color: $color-typography;
        }

        h2 {
            margin-top: 1.6em;
            margin-bottom: 0;
            line-height: 1;
        }

        p {
            margin-top: 0;
        }

        ul.progress-bar {
            margin: 0;
        }

        .assignment__information {
            margin: 1.2em 0 0.4em;
        }

        .assignment__meta {
            color: $color-grey;
            display: block;
            line-height: 1.5em;
        }

        .assignment__group-size {
            @include background-sprite-replace($icon-group-size-individual-group);
            display: inline-block;
            margin: 0 0 -3px 10px;
            &--individual {
                @include sprite-position($icon-group-size-individual);
            }
            &--pair {
                @include sprite-position($icon-group-size-pair);
            }
            &--trio {
                @include sprite-position($icon-group-size-trio);
            }
            &--multi {
                @include sprite-position($icon-group-size-multi);
            }
        }

    }


    .assignment-icon {

        width: $assignment-icon-size;
        height: $assignment-icon-size;

        border: $assignment-icon-border-size solid $color-white;

        display: block;
        background-color: #e5eae9;
        border-radius: 50%;
        box-sizing: content-box;

        @include sprite-image($icon-design-2x);
        @include sprite-background-size($icon-design);

        img {
            width: $assignment-icon-size;
            height: $assignment-icon-size;
            border: none;
        }

        @each $type, $value in $assignment-types {
            &.icon-#{$type} {
                @include sprite-position($value);
            }
        }

    }

</style>



// WEBPACK FOOTER //
// Route.vue?138189fc